import { useRouteError, isRouteErrorResponse, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export function ErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  let title = "오류가 발생했습니다";
  let message = "잠시 후 다시 시도해주세요.";

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      title = "페이지를 찾을 수 없습니다";
      message = "요청하신 페이지가 존재하지 않습니다.";
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-6 gap-6">
      <div className="text-center space-y-2">
        <h1 className="text-2xl font-bold">{title}</h1>
        <p className="text-muted-foreground">{message}</p>
      </div>
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => navigate(-1)}>
          뒤로가기
        </Button>
        <Button onClick={() => navigate("/main", { replace: true })}>
          홈으로
        </Button>
      </div>
    </div>
  );
}
